export const mobileInput = (v) => {
  let d = (v || "").replace(/\D/g, "").replace(/^0+/, "");
  if (d.length > 10 && d.startsWith("91")) d = d.slice(2);
  return d.slice(0, 10);
};

export const validMobile = (v) => /^[6-9]\d{9}$/.test(v || "");

export const mobileProps = { type: "tel", inputMode: "numeric", autoComplete: "tel-national", pattern: "[6-9][0-9]{9}" };

const STD = /^[A-Z]{2}\d{1,2}[A-Z]{0,3}\d{4}$/;
const BH = /^\d{2}BH\d{4}[A-Z]{1,2}$/;

export const vehicleInput = (v) => (v || "").toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 10);

export const validVehicle = (v) => STD.test(v || "") || BH.test(v || "");

export const fmtVehicle = (v) => {
  const s = vehicleInput(v);
  const b = s.match(/^(\d{2})(BH)(\d{4})([A-Z]{1,2})$/);
  if (b) return b.slice(1).join(" ");
  const m = s.match(/^([A-Z]{2})(\d{1,2})([A-Z]{0,3})(\d{4})$/);
  return m ? m.slice(1).filter(Boolean).join(" ") : s;
};

export const VehicleHint = ({ value }) => (value ? (
  <p className={`mt-1 text-xs ${validVehicle(value) ? "text-[#2E9E6B]" : "text-[#E05C3A]"}`} data-testid="vehicle-hint">
    {validVehicle(value) ? `✓ ${fmtVehicle(value)}` : "Format: RJ 14 AB 1234 (or 22 BH 1234 AA)"}
  </p>
) : null);

export const MobileHint = ({ value }) => (value && !validMobile(value) ? (
  <p className="mt-1 text-xs text-[#E05C3A]" data-testid="mobile-hint">{value.length < 10 ? `${10 - value.length} more digit${value.length === 9 ? "" : "s"}` : "Indian mobile numbers start with 6, 7, 8 or 9"}</p>
) : null);
